import {useEffect, useState} from 'react';
export const useSetTimeout = () => {
    const [timeOutId, setTimeOutIdCb] = useState<any>(null);
    const stopTimeOut = () => {
        timeOutId && clearTimeout(timeOutId);
        setTimeOutIdCb(null);
    };

    const _setTimeOut = (cb, delay) => {
        const id = setTimeout(() => {
            // eslint-disable-next-line callback-return
            cb();
            clearTimeout(timeOutId);
            setTimeOutIdCb(null);
        }, delay);

        setTimeOutIdCb(id);
    };

    useEffect(() => () => {
        stopTimeOut();
    }, []);

    return {_setTimeOut, timeOutId, stopTimeOut};
};
